"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("color:", theme.color.mainNav.color, ";height:100%;display:flex;flex-direction:column;.controlIconButton{color:", theme.color.mainNav.controlIconColor, ";svg{width:", theme.spacing[11], ";height:", theme.spacing[11], ";display:block;}&:hover{color:", theme.color.mainNav.controlIconColorHover, ";&::before{opacity:", theme.color.mainNav.controlIconHoverBackgroundOpacity, ";}}}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var scrollingContainer = process.env.NODE_ENV === "production" ? {
  name: "9xhbbe",
  styles: "flex-grow:1;overflow:hidden auto"
} : {
  name: "4dbenm-scrollingContainer",
  styles: "flex-grow:1;overflow:hidden auto;label:scrollingContainer;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var _ref = process.env.NODE_ENV === "production" ? {
  name: "rnau9s",
  styles: "display:flex;align-items:center;justify-content:space-between;h4{color:inherit;}"
} : {
  name: "1ivi80n-heading",
  styles: "display:flex;align-items:center;justify-content:space-between;h4{color:inherit;};label:heading;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var heading = function heading() {
  return _ref;
};

var controls = function controls(theme) {
  return /*#__PURE__*/(0, _react.css)("min-height:", theme.spacing[14], ";margin-left:auto;display:flex;align-items:center;margin-left:", theme.spacing[3], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:controls;"));
}; // this overwrites the behaviour of an icon button
// ideally, this should be set up in Button.styles when we have site-wide dark mode


var controlIconButton = function controlIconButton(theme) {
  return /*#__PURE__*/(0, _react.css)("color:", theme.color.mainNav.controlIconColor, ";svg{width:", theme.spacing[11], ";height:", theme.spacing[11], ";display:block;}&:hover{color:", theme.color.mainNav.controlIconColorHover, ";&::before{opacity:", theme.color.mainNav.controlIconHoverBackgroundOpacity, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:controlIconButton;"));
};

var list = function list(theme) {
  return /*#__PURE__*/(0, _react.css)("color:inherit;padding-left:", theme.spacing[10], ";padding-right:", theme.spacing[10], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:list;"));
};

var styles = {
  base: base,
  scrollingContainer: scrollingContainer,
  heading: heading,
  controls: controls,
  list: list,
  controlIconButton: controlIconButton
};
exports.styles = styles;
//# sourceMappingURL=Menu.styles.js.map